import _regeneratorRuntime from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/1/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import _imports_0 from '@/assets/images/voucher-whatapp.png';
import _imports_1 from '@/assets/images/icons/close_gray.svg';
var _hoisted_1 = {
  class: "member-qr"
};
var _hoisted_2 = {
  class: "info-name"
};
var _hoisted_3 = {
  class: "info-number"
};
var _hoisted_4 = ["src"];
var _hoisted_5 = {
  class: "code-desc"
};
var _hoisted_6 = {
  class: "task"
};
import accountAvatar from "@/assets/images/default_avatar.png";
import Image from "@/components/base/Image.vue";
import { onMounted, onUnmounted, ref } from "vue";
import { useUserStore } from "@/store/userStore.js";
import { getUserId } from "@/utils/authUtil";
import qrcode from "qrcode";
import { useSupplierStore } from "@/store/supplierStore";
import { QRCodeTypeEnum } from "@/constant/coupon";
import { checkScanQrcode } from "@/api/user";
import { onBeforeRouteLeave } from "vue-router";
import { useRouter } from "@/hooks/useRouter";
import { useI18n } from "vue-i18n";
export default {
  __name: 'MemberQr',
  setup: function setup(__props) {
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var _useRouter = useRouter(),
      routerPush = _useRouter.routerPush;
    var supplierStore = useSupplierStore();
    var userStore = useUserStore();
    var userId = userStore.getUserInfo.customer_id;
    var showWaChat = ref(false);
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return draw();
          case 2:
            _checkScan();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    var imgSrc = ref("");
    function draw() {
      var url = userId + "," + QRCodeTypeEnum.USER_CODE;
      qrcode.toDataURL(url, {
        width: 210,
        margin: 0
      }).then(function (res) {
        return imgSrc.value = res;
      });
    }
    function onClickToWaChat() {
      window.location.href = "https://wa.me/".concat(supplierStore.getWhatsappid, "/?text=").concat(encodeURIComponent(t("wantGetMoreVoucher")));
    }
    var timerId = ref(undefined);
    var _checkScan = function checkScan() {
      timerId.value = setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return checkScanQrcode(userId);
            case 2:
              res = _context2.sent;
              if (res.isOK && res.data && res.data.is_scan) {
                // 显示弹窗
                showWaChat.value = true;
              } else {
                _checkScan();
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      })), 3000);
    };
    onBeforeRouteLeave(function () {
      // 离开前清空轮询
      clearTimeout(timerId.value);
    });
    var handlePageBack = function handlePageBack() {
      routerPush({
        name: "Account"
      });
    };
    return function (_ctx, _cache) {
      var _component_van_popup = _resolveComponent("van-popup");
      var _component_Page = _resolveComponent("Page");
      return _openBlock(), _createBlock(_component_Page, {
        title: _ctx.$t('memberQR'),
        "on-back": handlePageBack
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [_createVNode(Image, {
            class: "imgStyle",
            src: _unref(userStore).user.avatar ? _unref(userStore).user.avatar : _unref(accountAvatar),
            "oss-stylename": "type_5"
          }, null, 8, ["src"]), _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(userStore).user.nickname), 1), _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("memberID")) + ": " + _toDisplayString(_unref(userId)), 1), _createElementVNode("img", {
            src: imgSrc.value,
            class: "code-img"
          }, null, 8, _hoisted_4), _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("showToCheckout")), 1)]), _createVNode(_component_van_popup, {
            show: showWaChat.value,
            style: {
              "border-radius": "12px",
              "background": "none"
            }
          }, {
            default: _withCtx(function () {
              return [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
                src: _imports_0,
                class: "img_style",
                onClick: onClickToWaChat
              }), _createElementVNode("img", {
                class: "close",
                src: _imports_1,
                alt: "",
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return showWaChat.value = false;
                })
              })])];
            }),
            _: 1
          }, 8, ["show"])];
        }),
        _: 1
      }, 8, ["title"]);
    };
  }
};